/* Built In Imports */
import { useRouter } from 'next/router';
import { useContext, useEffect, useState } from 'react';

/* External Imports */
import { Box, Button, Flex, Link, Text } from '@chakra-ui/react';
import { FaAngleDown } from 'react-icons/fa';

/* Internal Imports */
/* Components */
import config from '@config';
import CountriesList from '@constants/CountriesList';
import { AuthContext } from '@store/auth-context';

/* Services */
import { getCurrentRegion } from 'services/commonService';

/**
 * @param {object} sectionContent
 * @returns
 */
const FreeWebinar = (
    sectionContent
) => {

  const router = useRouter();
  const webinarClick = () => {
    if (typeof window !== 'undefined') {
      window.open('https://online.sadhguru.org/r/hytt-webinar', '_blank'); //https://events.sadhguru.org/lsr/mqHAIoQIbVm3iQm

    }
  };
  return (
      <Box bg="#FFAE27">
        <Box
         // maxW="1330px"
          px="45px"
          mx="auto"
          py={{ base: '25px', md: '20px' }}
          alignItems={{ base:'center', sm:'center', md: 'center',lg:'center' }}
          flexDir={{ base: 'column', md: 'row' }}
          display="flex"
          gridGap={{base:"24px",sm:"24px", md:"50px", lg:"50px"}}
          width={{lg:'850px'}}
        >
          <Text 
          color="#000000"  
          textAlign={'center'} 
          fontFamily="FedraSansStd-book"
          fontSize={{base:'22px', sm:"22px", md:"24px",lg:"24px"}}
          fontWeight={'450'}
          lineHeight={{base:'30px', sm:"30px", md:"36px", lg:"36px"}}
          >
          
          {sectionContent.sectionContent[0].text}
          </Text>           
            <Box
              fontFamily="FedraSansStd-medium"
              border="2px"
              fontWeight="500"
              bgColor="#FFAE27"
              color={'#000000'}
              borderColor={'#000000'}
              borderRadius={'5px'}
              height={'58px'}
              width={'262px'}
              fontSize={'20px'}
              cursor={'pointer'}
              textAlign={'center'}
              paddingTop={'10px'}
              onClick={() => webinarClick()}
            >
              {sectionContent.sectionContent[1].buttonText}
            </Box>
        </Box>
      </Box>
  );
};

export default FreeWebinar;
